<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t('propertydetails.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">{{$t('participateWin')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="text-center" v-if="isLoading">
          <mainloader />
        </div>

        <div class="row" v-else>
          <div class="col">
            <div v-html="row.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "participateWin",
  data(){
    return{
      hasError: false,
      isLoading: false,
      message: "",
      errorNumber: null,
      row: {},
      userLang: 'ar',
    }
  },
  methods:{
    getParticipateWin(){
      this.hasError = false;
      this.isLoading = true;
      this.$http.get('/api/shareWin/show').then(res => {
        // console.log(res);
        this.row = res.data.row;
        this.isLoading = false;
      }).catch(err => {
        console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err , true);
        this.hasError = true;
        this.isLoading = false;
      })
    },
  },
  created(){
    this.getParticipateWin();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior:'smooth'});
  }
}
</script>